import { computed, type Ref } from "vue";
import type { Editable } from "hoxton-types";

import { deepClone } from "@/utils";
import { useMasterTemplates } from "@/composables/useMasterTemplates";

export function useEditable({ editable }: { editable: Ref<Editable> }) {
    const { masterTemplateLabels } = useMasterTemplates();

    const editableTemplates = computed(() =>
        editable.value?.defaultValues.map(defaultValue => defaultValue.masterTemplateId)
    );

    const templateLabels = computed(() => {
        const labels = deepClone(masterTemplateLabels.value);

        Object.keys(labels).forEach(masterTemplateId => {
            if (!editableTemplates.value?.includes(masterTemplateId)) {
                delete labels[masterTemplateId];
            }
        });

        return labels;
    });

    return {
        editableTemplates,
        templateLabels
    };
}
